const strateIntroCsm = {
    init() {
        const strate = document.querySelector('.strate-intro-csm');
        if (strate) {
            const progressBars = document.querySelectorAll('.projet_bottom .progress_bar');
            progressBars.forEach((bar, step) => {
                const delay = step * 250;
                setTimeout(function() {
                        bar.classList.remove('init');
                }, delay);
            });
        }
    },
};

export default strateIntroCsm;
